<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="copyright">
<p class="copyrightText3">This edition of <em class="italic">King of Airfighters</em> is published in the United States of America in 2009 by</p>
<p class="copyrightText">CASEMATE</p>
<p class="copyrightText">908 Darby Road, Havertown, PA 19083</p>
<p class="copyrightText1">and in the United Kingdom by</p>
<p class="copyrightText">CASEMATE</p>
<p class="copyrightText">17 Cheap Street, Newbury, RG14 5DD</p>
<p class="centerImageC"><img alt="images" id="logo1" src="images/logo1.jpg"/></p>
<p class="copyrightText1">This edition Copyright © 1989 &amp; 2009 Lionel Leventhal Ltd,</p>
<p class="copyrightText1">Typeset &amp; Design © 2009 Casemate Publishers</p>
<p class="copyrightText1">ISBN: 978-1-932033-99-1</p>
<p class="copyrightText"> Digital Edition ISBN: 978-1-935149-77-4</p>
<p class="copyrightText1">Cataloging in publication data is available from the Library of Congress and the British Library.</p>
<p class="copyrightText1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording or otherwise without the prior permission of the publishers.</p>
<p class="copyrightText1">Printed and bound in the United States of America</p>
<p class="copyrightText">908 Darby Road</p>
<p class="copyrightText">Havertown PA, 19083</p>
<p class="copyrightText1">Publishing History:</p>
<p class="copyrightText"><em class="italic">King of Airfighters</em> was first published by Ivor, Nicolson and Watson in 1934. It was reissued in facsimile by Greenhill Books/Lionel Leventhal Ltd in 1989. This new edition has been completely retypeset but the original language has been left unaltered.</p>
<p class="centerImageC"><img alt="images" id="logo2" src="images/logo2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KingofAirfighters_copyright.vue?db808b76